import { createSelector } from 'reselect';

export const getUsersFilters = createSelector(state => state.UsersFilter, r => r);